/* eslint-disable max-len */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LineItemListService {
  productColumnsConfigs = [
    { key: 'checkbox', headerClass: 'w-1/12' },
    { label: 'symbol.#', key: 'id', headerClass: 'w-1/12' },
    { label: 'symbol.#', key: 'index', headerClass: 'w-1/12' },
    { key: 'select', headerClass: 'w-1/12' },
    { label: '', key: 'approval_status', headerClass: 'w-1/12' },
    { label: 'asset.details.product.no.label', key: 'product_id', headerClass: 'w-1/12' },
    { label: 'text.part_name', key: 'product_name', headerClass: 'w-5/12' },
    { label: 'product.text', key: 'product', headerClass: 'w-5/12' },
    { label: 'category.text', key: 'category', headerClass: 'w-3/12' },
    { label: 'brand', key: 'brand', headerClass: 'w-3/12' },
    { label: 'text.specification', key: 'specification', headerClass: 'w-3/12' },
    { label: 'text.location', key: 'location', headerClass: 'w-3/12' },
    { label: 'text.type', key: 'line_item_type', headerClass: 'w-3/12' },
    { label: 'text.qty', key: 'quantity', headerClass: 'w-2/12' },
    { label: 'text.current.availability', key: 'current_availability', headerClass: 'w-4/12' },
    { label: 'text.serial_number', key: 'serial_no', headerClass: 'w-4/12' },
    { label: 'text.price', key: 'price', headerClass: 'w-3/12' },
    { label: 'amount', key: 'amount', headerClass: 'w-2/12' },
    { label: 'text.discount', key: 'discount', headerClass: 'w-2/12' },
    { label: 'text.tax_code', key: 'taxcode', headerClass: 'w-2/12' },
    { label: 'text.total', key: 'total', headerClass: 'w-2/12' },
    { label: 'actions.text', key: 'action', headerClass: 'w-2/12' }
  ];
}
